import moment from 'moment';

export const DEFAULT_AGG_SIZE = 10000;

export const DEFAULT_STATISTICS_TYPE = 'DAILY_SALES';

export const typesOfSaleStatistic = [
  { key: 'DAILY_SALES', label: 'salesFilters.Daily product sales statistics' },
  { key: 'POPULAR_PRODUCTS',  label: 'salesFilters.Popular products and product categories' },
  { key: 'EMPLOYEES_SALES', label: 'salesFilters.Sales by employee' },
];

export const START_DATE_RANGE = {
  selection1: {
    startDate: moment().subtract(1, 'week').toDate(),
    endDate: moment().toDate(),
    key: 'selection1'
  }
};